import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { Select } from '~/vcl/atoms/01-forms/05-select';
import { getAgencyOrganizations } from '~/jobiqo/components/Organization/queries/getOragizationQuery';
import { SelectItem } from '~/vcl/models/forms';
import { useIntl } from 'react-intl';
import { useConfig } from '~/jobiqo/context/config';
import { isRecruiter } from '~/jobiqo/lib/auth';

export function getAgencyOrganizationFields(user, entity) {
  const { getConfigByName } = useConfig();
  const AGENCY_FEATURE_ACTIVE: boolean = !!getConfigByName(
    'jobiqo_organization_agency',
  )?.value[0];

  const intl = useIntl();
  const { data: agencyOrganizations, loading, error } = useQuery(
    getAgencyOrganizations(),
    {
      variables: { id: user?.organization?.id },
      skip: !AGENCY_FEATURE_ACTIVE || !isRecruiter(user),
    },
  );

  const [groupOrganizations, setGroupOrganizations] = useState<SelectItem[]>(
    [],
  );
  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  useEffect(() => {
    if (agencyOrganizations && agencyOrganizations.getAgencyOrganizations) {
      const organizations = agencyOrganizations.getAgencyOrganizations.map(
        (organization) => ({
          code: organization.id.toString(),
          name: organization.name,
        }),
      );
      // Add an option for the user to unassign the job from the organization to organizations array
      organizations.unshift({
        code: 'none',
        name: intl.formatMessage({
          id: 'agency_recruiter_unassign_group',
          defaultMessage: 'No organization assigned',
        }),
      });

      setGroupOrganizations(organizations);
      if (entity && entity.field_organization_assignment) {
        setSelectedValue(entity.field_organization_assignment);
      }
    }
  }, [agencyOrganizations, entity, intl]);

  if (loading) {
    return <div>Loading organizations...</div>;
  }
  if (error) {
    return <div>Error loading organizations: {error.message}</div>;
  }

  const handleChange = (field, setFieldValue) => (item: SelectItem | null) => {
    if (item) {
      setSelectedValue(item.code);
      setFieldValue(field.id, item.code);
    } else {
      setSelectedValue(null);
      setFieldValue(field.id, null);
    }
  };

  return {
    field_organization_assignment: ({ field, values, setFieldValue }) => {
      // If the user is recruiter and there is no organizations return null
      if (!isRecruiter(user) || !groupOrganizations.length) {
        return null;
      }
      return (
        <div key={field.id}>
          <Select
            id={field.id}
            items={groupOrganizations}
            name={field.id}
            selectedValue={selectedValue ?? ''}
            onChange={handleChange(field, setFieldValue)}
            label={field.label}
            description={field.description}
          />
        </div>
      );
    },
  };
}
